import axios from "axios";
import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import Loader from "../../components/Loader";
import Modal from "../../components/Modal/Modal";
import useAuth from "../../hooks/useAuth";
import { BASE_URL } from "../../utils/Element";
import AddClosedData from "./components/AddClosedData";

const initialData = {
  under_contract_id: "",
  property: { id: "", name: "" },
  company_gcl: "",
  contract_price: "",
  contract_cap_rate: "",
  closing_date: "",
  initial_date: "",
  contract_date: "",

};

const EditClosedModal = ({ showModal, onClose, onCallApi, id }) => {
  const [config] = useAuth();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(initialData);
  const [disable, setDisable] = useState(false);
  const [isDollar, setIsDollar] = useState(false)

  const handleClose = () => {
    setFormData(initialData);
    onClose();
  };

  useEffect(() => {
    if (id && showModal) {
      setLoading(true);
      axios
        .get(`${BASE_URL}/close/${id}`, config)
        .then((res) => {
          const data = res?.data?.close;
          setFormData({
            under_contract_id: data.under_contract_id,
            portfolio: data?.portfolio === 1 ? 1 : 0,
            property: {
              id: data?.contract?.executed?.link?.id,
              name: data?.contract?.executed?.link?.property_name,
            },
            company_gcl: data.contract?.executed?.company_gcl,
            contract_price: data.contract?.executed?.contract_price,
            contract_cap_rate: data.contract?.executed?.contract_cap_rate,
            closing_date: data.close_date,
            initial_date: data.inital_date,
            contract_date: data.contract_date,
            company_gcl_type: data ? "dollar" : "percent",

          });
        })
        .catch((err) => {
          if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
            NotificationManager.error(err.response?.data?.message);
          }
        })
        .finally(() => setLoading(false));
    }
  }, [id, showModal]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setDisable(true);
    const dataToSend = {
      under_contract_id: formData.under_contract_id,
      property: formData.property,
      portfolio: formData?.portfolio === 1 ? 1 : 0,
      company_gcl: formData.company_gcl,
      company_gcl_type: isDollar ? "dollar" : "percent",
      contract_price: formData.contract_price,
      contract_cap_rate: formData.contract_cap_rate,
      closing_date: formData.closing_date,
      initial_date: formData.initial_date,
      contract_date: formData.contract_date,
    };

    axios
      .post(`${BASE_URL}/update-close/${id}`, dataToSend, config)
      .then((res) => {
        handleClose();
        onCallApi();
      })
      .catch((err) => {
        setError(err.response?.data?.errors);
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      })
      .finally(() => setDisable(false));
  };

  const handleChange = (value, name) => {
    setError({ ...error, [name]: "" });
    setFormData({ ...formData, [name]: value });
  };

  return (
    <Modal title={`Edit Closed`} desc={`Edit the Closed information.`} show={showModal} onClose={onClose}>
      {loading ? (
        <Loader />
      ) : (
        <AddClosedData
          formData={formData}
          error={error}
          onSetFormData={(value) => {
            setFormData(value);
          }}
          onSetError={(value) => setError(value)}
          isDollar={isDollar}
          setIsDollar={setIsDollar}
          handleClose={handleClose}
          showModal={showModal}
          handleSubmit={handleSubmit}
          handleChange={handleChange}
          disable={disable}
        />
      )}
    </Modal>
  );
};

export default EditClosedModal;
